import React from 'react'
import { Switch } from 'react-router-dom'
import Loadable from './Loadable'
import { PrivateRoute, PublicRoute } from '../../../lib/routePermission'


// const AsyncHome = Loadable({
//     loader: () => import('./Home')
// })

const AsyncNotFound = Loadable({
    loader: () => import('./NotFound')
})

const AsyncHomeDisplay = Loadable({
    loader: () => import('../../display/components/pages/home')
})

export default () => (
    <Switch>
        <PublicRoute exact path='/' component={AsyncHomeDisplay} />
        {/* <PublicRoute path='/test' component={AsyncHomeDisplay} /> */}

        <PrivateRoute component={AsyncNotFound} />
    </Switch>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/Routes.js